import { FC, ReactNode } from "react";
import { CXAdminTopbar } from "./components/CXAdminTopbar/CXAdminTopbar";
import { CXAdminSidebar } from "./components/CXAdminSidebar";

interface CXWorkspaceAdminLayoutProps {
  children: ReactNode;
}

export const CXWorkspaceAdminLayout: FC<CXWorkspaceAdminLayoutProps> = ({
  children,
}) => (
  <div className="flex h-full flex-col">
    <CXAdminTopbar />
    <CXAdminSidebar>{children}</CXAdminSidebar>
  </div>
);
